// CF7確認画面の管理クラス
class CF7FormManager {
  constructor(inputArea) {
    this.inputArea = inputArea;
    this.privacy = inputArea.querySelector('#js-privacy, #men-js-privacy, #women-js-privacy');
    this.confirmButton = inputArea.querySelector(".js-confirmBtn");
    this.requiredInputs = inputArea.querySelectorAll('[aria-required="true"]');

    // フラグ
    this.requireFlg = false;
    this.privacyFlg = false;
    this.errFlg = true;

    this.init();
  }

  init() {
    this.setupInitialRadioValues();
    this.setupFormInputs();
    this.setupConfirmButton();
    this.setupBackButton();
    this.setupValidation();
  }

  // ラジオボタンの初期値を設定
  setupInitialRadioValues() {
    const radioButtons = this.inputArea.querySelectorAll('[type="radio"]:checked');
    radioButtons.forEach(button => {
      const name = button.closest('[name]').name;
      const confirmElement = document.querySelector(`[data-input-name="${name}"]`);
      if (confirmElement) {
        confirmElement.textContent = button.value;
      }
    });
  }

  // フォーム入力の変更を監視
  setupFormInputs() {
    const formInputs = this.inputArea.querySelectorAll('input, select, textarea');
    formInputs.forEach(input => {
      input.addEventListener('change', (e) => this.handleInputChange(e));
    });
  }

  // 入力変更の処理
  handleInputChange(event) {
    const input = event.target;
    const type = input.getAttribute("type");
    const name = input.name;
    const confirmElement = document.querySelector(`[data-input-name="${name}"]`);

    if (!confirmElement) return;

    switch (type) {
      case "radio":
        confirmElement.textContent = input.value;
        break;
      case "checkbox":
        if (input !== this.privacy) {
          confirmElement.textContent += input.value + " / ";
        }
        break;
      case "file":
        confirmElement.textContent = input.files[0]?.name || '';
        break;
      default:
        confirmElement.textContent = input.value;
    }
  }

  // 確認ボタンの設定
  setupConfirmButton() {
    if (!this.confirmButton) return;

    this.confirmButton.addEventListener('click', () => {
      const currentInputArea = this.confirmButton.closest('.js-inputArea');
      const currentConfirmArea = currentInputArea.parentElement.querySelector('.js-confirmArea');

      if (currentInputArea && currentConfirmArea) {
        currentInputArea.style.display = 'none';
        currentConfirmArea.style.display = 'block';
        window.scrollTo(0, document.querySelector('.js-header').getBoundingClientRect().top);
      }
    });
  }

  // 戻るボタンの設定
  setupBackButton() {
    const backButton = this.inputArea.parentElement.querySelector(".js-backBtn");
    if (!backButton) return;

    backButton.addEventListener('click', () => {
      const currentInputArea = backButton.closest('.js-confirmArea').parentElement.querySelector('.js-inputArea');
      const currentConfirmArea = backButton.closest('.js-confirmArea');

      if (currentInputArea && currentConfirmArea) {
        currentInputArea.style.display = 'block';
        currentConfirmArea.style.display = 'none';
        this.resetOtherForms(currentInputArea);
      }
    });
  }

  // 他のフォームをリセット
  resetOtherForms(currentInputArea) {
    const otherFormContainers = document.querySelectorAll('#men, #women');
    otherFormContainers.forEach(container => {
      if (!container.contains(currentInputArea)) {
        container.style.display = '';
        const otherInput = container.querySelector('.js-inputArea');
        const otherConfirm = container.querySelector('.js-confirmArea');
        if (otherInput) otherInput.style.display = 'block';
        if (otherConfirm) otherConfirm.style.display = 'none';
      }
    });
  }

  // バリデーションの設定
  setupValidation() {
    this.setupPrivacyValidation();
    this.setupRequiredValidation();
  }

  // プライバシーポリシーのバリデーション
  setupPrivacyValidation() {
    if (!this.privacy) return;

    this.privacy.addEventListener('change', () => {
      this.privacyFlg = this.privacy.checked;
      this.updateSubmitButton();
    });
  }

  // 必須項目のバリデーション
  setupRequiredValidation() {
    this.requiredInputs.forEach(input => {
      input.addEventListener('input', () => {
        this.requireFlg = this.checkRequiredFields();
        this.updateSubmitButton();
      });

      input.addEventListener('blur', () => {
        this.errorCheck();
        this.updateSubmitButton();
      });
    });
  }

  // 必須項目のチェック
  checkRequiredFields() {
    return Array.from(this.requiredInputs).every(input => input.value !== "");
  }

  // エラーチェック
  errorCheck() {
    this.errFlg = !!this.inputArea.querySelector('.wpcf7-not-valid-tip');
  }

  // 送信ボタンの状態更新
  updateSubmitButton() {
    if (!this.confirmButton) return;

    this.confirmButton.disabled = !(this.requireFlg && this.privacyFlg && !this.errFlg);
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  const inputAreas = document.querySelectorAll('.js-inputArea');
  if (inputAreas.length === 0) return;

  inputAreas.forEach(inputArea => {
    new CF7FormManager(inputArea);
  });
});
